import React from 'react';
import {setPageMeta} from "../utils/metaHelper";

class Page404 extends React.Component {
    componentDidMount() {
        setPageMeta('404 - Page not found', {"description":"404 - Page not found","robots":"noarchive, noindex"});
    }
    render() {
        window.scrollTo(0, 0);
        return (
            <div className="container-fluid main-content-container" style={{ marginTop: "148px" }}>
                <div className="row">
                    <div className="col-12">
                        <p>
                            Diese Seite existiert nicht oder wurde dauerhaft verschoben.
                        </p>
                    </div>
                </div>
            </div>)};
}
export default Page404;
